import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../../web/components-v2/Theme/theme';
import { background, charmGray } from '../../../../../web/styles/colors';

const { colors } = THEME;

export const avatarUploaderStyles = StyleSheet.create({
	container: {
		position: 'relative',
		display: 'inline-flex',
	},
	dropArea: {
		position: 'relative',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		width: 64,
		height: 64,
		overflow: 'hidden',
		borderRadius: '50%',
		border: `1px dashed ${charmGray}`,
		backgroundColor: 'transparent',
		cursor: 'pointer',
		outline: 'none',
		transition: 'all 0.2s ease',
		':hover': {
			backgroundColor: background,
		},
		':focus-visible': {
			borderColor: colors.primary.main,
			boxShadow: `0 0 0 3px ${colors.primary.light}`,
		},
	},
	dropAreaDragging: {
		backgroundColor: colors.hover.light,
		borderColor: colors.primary.main,
	},
	dropAreaWithImage: {
		border: 'none',
	},
	dropAreaDisabled: {
		pointerEvents: 'none',
		opacity: 0.5,
	},
	previewImage: {
		width: '100%',
		height: '100%',
		objectFit: 'cover',
	},
	iconContainer: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		opacity: 0.6,
	},
	removeButton: {
		position: 'absolute',
		top: -4,
		right: -4,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		width: 24,
		height: 24,
		borderRadius: '50%',
		backgroundColor: charmGray,
		color: '#FFFFFF',
		border: '2px solid #FFFFFF',
		cursor: 'pointer',
		boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
		transition: 'all 0.2s ease',
	},
	hiddenInput: {
		position: 'absolute',
		width: 1,
		height: 1,
		padding: 0,
		margin: -1,
		overflow: 'hidden',
		clip: 'rect(0, 0, 0, 0)',
		whiteSpace: 'nowrap',
		border: 0,
	},
	uploadingOverlay: {
		position: 'absolute',
		top: 0,
		left: 0,
		width: '100%',
		height: '100%',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		backgroundColor: 'rgba(255, 255, 255, 0.7)',
		borderRadius: '50%',
	},
});
